var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jmreport-report-page" }, [
    _c("iframe", {
      key: _vm.iframeKey,
      staticClass: "jmreport-report-page__iframe",
      attrs: { src: _vm.iframeSrc, frameborder: "0" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }